import { icon, extension } from '~utils/file'
import moment from 'moment'
export function convertMedia(media) {
  if (!media || media.length === 0) return []
  return media.length
    ? media.map(pieceMedia => convertAttachment(pieceMedia))
    : [convertAttachment(media)]
}

export function convertAttachment(attachment) {
  return {
    attachment_id: attachment.id,
    attachment_file_name: attachment.file_name,
    attachment_file_extension: extension(attachment.mime_type),
    attachment_url: attachment.url,
    attachment_icon: icon(attachment.mime_type),
    attachment_size: attachment.size,
    attachment_type: attachment.mime_type
  }
}

export function convertPages(meta) {
  return {
    page_current: meta.current_page,
    page_total: Math.ceil(meta.total / meta.per_page),
    page_amount: meta.per_page,
    item_quantity: meta.to - (meta.from - 1),
    item_from: meta.from,
    item_to: meta.to
  }
}

const typeDefaultValue = {
  text: '',
  number: 'NaN',
  boolean: 'false',
  'boolean-number': 0
}

export function convertEnterpriseRequest(request) {
  const newRequest = {
    account: request.enterprise_gui_number || typeDefaultValue.text,
    name: request.enterprise_name || typeDefaultValue.text,
    principal: request.enterprise_owner || typeDefaultValue.text,
    established_at: request.enterprise_founded_date,
    staff_count: Number(request.enterprise_employee_number),
    capital: request.enterprise_registered_capital || typeDefaultValue.text,
    job_category_id: request.enterprise_industry || typeDefaultValue.number,
    url: request.enterprise_website || typeDefaultValue.text,
    address: request.enterprise_address || typeDefaultValue.text,
    tel: request.enterprise_tel || typeDefaultValue.text,
    fax: request.enterprise_fax || typeDefaultValue.text,
    provide_internship: Number(request.enterprise_hire_interns) || typeDefaultValue['boolean-number'],
    provide_foreigners: Number(request.enterprise_hire_foreigners) || typeDefaultValue['boolean-number'],
    provide_handicapped: Number(request.enterprise_hire_disabled_people) || typeDefaultValue['boolean-number'],
    education_training: request.enterprise_employee_training_introduction || typeDefaultValue.text,
    introduction: request.enterprise_introduction || typeDefaultValue.text,
    welfare: request.enterprise_employee_benefits || typeDefaultValue.text,
    note: request.enterprise_remark || typeDefaultValue.text,
    // specialIssue
    job_description: request.enterprise_services || typeDefaultValue.text, // 營業項目
    contact: request.enterprise_hr_contact_person || typeDefaultValue.text,
    email: request.enterprise_hr_contact_email || typeDefaultValue.text,
    contact_tel: request.enterprise_hr_contact_tel || typeDefaultValue.text,
    relationship_enterprise: request.enterprise_related_company,
    is_daylight: Number(request.enterprise_is_nine_to_five),
    is_shift: Number(request.enterprise_is_shift_work), // TODO convert time to start_date, end_date,
    is_flextime: Number(request.enterprise_is_flextime),
    daylight_start_date: request.enterprise_shift_schedule.length > 0
      ? moment(request.enterprise_shift_schedule[0].start_time).format(
        'HH:mm'
      )
      : '09:00',
    daylight_end_date: request.enterprise_shift_schedule.length > 0
      ? moment(request.enterprise_shift_schedule[0].end_time).format('HH:mm')
      : '18:00',
    talent_content: request.enterprise_recruiting_description,
    remark: request.enterprise_work_portfolio,
    // en
    en_name: request.enterprise_name_en || typeDefaultValue.text,
    en_address: request.enterprise_address_en || typeDefaultValue.text,
    en_contact: request.enterprise_hr_contact_person_en || typeDefaultValue.text,
    en_relationship_enterprise: request.enterprise_related_company_en || typeDefaultValue.text,

    en_job_description: request.enterprise_services_en || typeDefaultValue.text,
    en_welfare: request.enterprise_employee_benefits_en || typeDefaultValue.text,
    en_education_training: request.enterprise_employee_training_introduction_en || typeDefaultValue.text,
    en_talent_content: request.enterprise_recruiting_description_en || typeDefaultValue.text,
    en_remark: request.enterprise_work_portfolio_en || typeDefaultValue.text,
    en_note: request.enterprise_note_en || typeDefaultValue.text
  }

  newRequest.shift_period = request.enterprise_shift_schedule.map(shift => {
    return {
      start_time: moment(shift.start_time).format('HH:mm'),
      end_time: moment(shift.end_time).format('HH:mm')
    }
  })
  if (Object.keys(request.enterprise_logo).length > 0) {
    newRequest.old_logo = request.enterprise_logo.attachment_id
  }

  if (Object.keys(request).includes('enterprise_new_logo')) {
    newRequest.logo = request.enterprise_new_logo
    newRequest.old_logo = ''
  }

  let formData = new FormData()
  Object.keys(newRequest).forEach(key => {
    if (key === 'old_logo') {
      if (newRequest[key]) {
        formData.append(`${key}[${newRequest[key]}]`, '')
      }
    } else if (key === 'shift_period') {
      newRequest[key].forEach((shift, index) => {
        Object.keys(shift).forEach(time => {
          formData.append(`${key}[${index}][${time}]`, shift[time])
        })
      })
    } else {
      if (!request.enterprise_hire_foreigners) {
        if (!(key.includes('en_') && !newRequest[key])) {
          formData.append(key, newRequest[key])
        }
      } else {
        formData.append(key, newRequest[key])
      }
    }
  })
  return formData
}

export function convertEnterpriseResponse(response) {
  return {
    enterprise_id: response.id,
    enterprise_gui_number: response.account,
    enterprise_name: response.name,
    enterprise_en_name: response.en_name,
    enterprise_owner: response.principal,
    enterprise_founded_date: moment(response.established_at).format('YYYY-MM-DDTHH:mm:ss.SSSZ') || '',
    enterprise_employee_number: response.staff_count,
    enterprise_registered_capital: response.capital,
    enterprise_industry: response.job_category_id,
    enterprise_industry_description: response.job_description,
    // enterprise_contact_person: response.contact,
    // enterprise_contact_email: response.email,
    enterprise_website: response.url,
    enterprise_address: response.address,
    enterprise_tel: response.tel,
    enterprise_fax: response.fax,
    enterprise_hire_interns: Boolean(response.provide_internship),
    enterprise_hire_foreigners: Boolean(response.provide_foreigners),
    enterprise_hire_disabled_people: Boolean(response.provide_handicapped),
    enterprise_employee_training_introduction: response.education_training.replaceAll(/\r\n/g, '\n'),
    enterprise_introduction: response.introduction.replaceAll(/\r\n/g, '\n'),
    enterprise_employee_benefits: response.welfare.replaceAll(/\r\n/g, '\n'),
    enterprise_remark: response.note,
    enterprise_logo: !response.media ? '' : convertMedia(response.media)[0],
    // Special Issue
    enterprise_services: response.job_description,
    enterprise_related_company: response.relationship_enterprise,
    enterprise_shift_schedule: response.is_shift
      ? response.shift_period.map(shift => {
        return {
          start_time: `${moment().format('YYYY-MM-DD')} ${shift.start_time}`,
          end_time: `${moment().format('YYYY-MM-DD')} ${shift.end_time}`
        }
      })
      : [
        {
          start_time: `${moment().format(
            'YYYY-MM-DD'
          )} ${response.daylight_start_date || '09:00'}`,
          end_time: `${moment().format(
            'YYYY-MM-DD'
          )} ${response.daylight_end_date || '18:00'}`
        }
      ],
    enterprise_is_nine_to_five: Boolean(response.is_daylight) ||
      (!response.is_daylight && !response.is_shift),
    enterprise_is_shift_work: Boolean(response.is_shift),
    enterprise_is_flextime: Boolean(response.is_flextime),
    enterprise_recruiting_description: response.talent_content.replaceAll(/\r\n/g, '\n'),
    enterprise_hr_contact_person: response.contact,
    enterprise_hr_contact_tel: response.contact_tel,
    enterprise_hr_contact_email: response.email,
    enterprise_work_portfolio: response.remark,
    // en
    enterprise_name_en: response.en_name,
    enterprise_address_en: response.en_address,
    enterprise_hr_contact_person_en: response.en_contact,
    enterprise_related_company_en: response.en_relationship_enterprise,
    enterprise_services_en: response.en_job_description,
    enterprise_employee_benefits_en: response.en_welfare,
    enterprise_employee_training_introduction_en: response.en_education_training,
    enterprise_recruiting_description_en: response.en_talent_content,
    enterprise_note_en: response.en_note,
    enterprise_work_portfolio_en: response.en_remark
  }
}

export function convertAppointmentAvailableTimeSlots(slots) {
  if (!slots.length) {
    return []
  }
  const availableTimeSlots = []
  slots.forEach((slot) => {
    if (moment().isBefore(slot.date, 'day')) {
      availableTimeSlots.push({
        appointment_counselor_id: slot.id,
        appointment_date: slot.date,
        appointment_time_start: slot.start,
        appointment_time_end: slot.end
      })
    }
  })
  return availableTimeSlots
}

export function convertCareerCounsellingResponse(response) {
  return {
    counselor_id: response.id,
    counselor_name: response.name,
    counselor_work_for: response.unit,
    counselor_title: response.position,
    counselor_group_name: response.group_name,
    counselor_group_limit: response.group_limit,
    counselor_group_Id: response.group_id,
    counselor_open_item_ids: response.open_item_ids,
    counselor_multiple_enable: response.multiple_enable,
    counselor_avatar: convertMedia(response.media)

  }
}

export function convertCampusRecruitingIndexResponse(response) {
  return {
    recruitment_id: response.id,
    recruitment_name: response.name,
    enroll_start_date: response.r_start_date,
    enroll_end_date: response.r_end_date,
    orientation_name: response.enlistSeminar.name,
    orientation_start_date: response.enlistSeminar.start_date,
    orientation_end_date: response.enlistSeminar.end_date,
    expo_name: response.enlistExposition.name,
    expo_date: response.enlistExposition.start_date,
    has_orientation: response.enlist_seminar_enable,
    has_expo: response.enlist_exposition_enable
  }
}

export function convertCampusRecruitingDetailsBasicInfo(response) {
  return {
    recruitment_id: response.id,
    recruitment_name: response.name,
    recruitment_enrollment_start_date: response.r_start_date,
    recruitment_enrollment_end_date: response.r_end_date,
    recruitment_payment_due_date: response.p_end_date,
    recruitment_fax: response.fax,
    recruitment_tel: response.tel,
    recruitment_email: response.email,
    recruitment_contact_person: response.contact,
    recruitment_bank_branch: response.bank_name,
    recruitment_account_number: response.bank_account,
    recruitment_account_name: response.bank_account_name,
    recruitment_business_proposal: convertMedia(response.media).length ? convertMedia(response.media) : null,
    recruitment_session_pdf: convertMedia(response.media2).length ? convertMedia(response.media2) : null,
    recruitment_orientation_enabled: Boolean(response.enlist_seminar_enable),
    career_expo_enabled: Boolean(response.enlist_exposition_enable),
    print_advertising_enabled: Boolean(response.enlist_commodity_enable)
  }
}

export function converCampusRecruitingDetailsSpecialIssue(response) {
  return {
    enterprise_services: response.job_description,
    enterprise_related_company: response.relationship_enterprise,
    enterprise_shift_schedule: response.is_daylight
      ? [{
        start_time: `${moment().format('YYYY-MM-DD')} ${response.daylight_start_date}`,
        end_time: `${moment().format('YYYY-MM-DD')} ${response.daylight_end_date}`
      }]
      : response.shift_period.map(shift => {
        return {
          start_time: `${moment().format('YYYY-MM-DD')} ${shift.start_time}`,
          end_time: `${moment().format('YYYY-MM-DD')} ${shift.end_time}`
        }
      }),
    enterprise_is_nine_to_five: Boolean(response.is_daylight),
    enterprise_is_shift_work: Boolean(response.is_shift),
    enterprise_is_flextime: Boolean(response.is_flextime),
    enterprise_hire_interns: Boolean(response.provide_internship),
    enterprise_hire_foreigners: Boolean(response.provide_foreigners),
    enterprise_hire_disabled_people: Boolean(response.provide_handicapped),
    enterprise_employee_benefits: response.welfare,
    enterprise_employee_training_introduction: response.education_training,
    enterprise_recruiting_description: response.content,
    enterprise_hr_contact_person: response.contact,
    enterprise_hr_contact_tel: response.contact_tel,
    enterprise_hr_contact_email: response.contact_email,
    enterprise_work_portfolio: response.remark
  }
}

export function converCampusRecruitingDetailsEnrolledExpo(response) {
  const expoNumbers = response.enlistExpositions.map(expo => expo.booth_number)
  const expoNames = response.enlistExpositions.map(expo => ({
    booth_id: expo.booth_number,
    booth_name: expo.booth_name,
  }))
  // 這邊有可能是0 , 即使是0 還是應該要呈現資料
  // 0的情況 => 購買(4) - 授權(4) + 取得(0) = 0
  if (response.enlist_exposition_count > -1) {
    const expo = {
      expo_booth_quantity: response.origin_enlist_exposition_count,
      expo_booth_numbers: expoNumbers,
      expo_booth_names: expoNames,
      expo_booth_give_enterprise: response.giveEnterprise,
      expo_booth_take_enterprise: response.takeEnterprise,
      expo_booth_final_quantity: response.enlist_exposition_count,
    }
    return expo
  }
  return {}
}

export function converCampusRecruitingDetailsEnrolledOrientations(response) {
  if (!response.length) {
    return {}
  }
  const orientations = response.map(orientation => {
    return {
      orientation_date_id: orientation.id,
      orientation_date: moment(orientation.enlistSeminarDate.seminar_date).format('YYYY/MM/DD'),
      orientation_start_time: orientation.start_date,
      orientation_end_time: orientation.end_date,
      orientation_charge: orientation.price,
      duration: `${orientation.start_date}~${orientation.end_date}`
    }
  })
  return {
    orientation_price: orientations[0].orientation_charge,
    orientation_slots: orientations,
    orientation_charge_total: orientations.reduce((accumulator, currentValue) => accumulator + currentValue.orientation_charge, 0)
  }
}

export function converCampusRecruitingDetailsEnrolledAdvertisements(response) {
  if (!response.length) {
    return {}
  }
  const advertisements = response.map(ad => {
    return {
      ad_id: ad.id,
      ad_item: ad.name,
      ad_unit_price: ad.price,
      ad_max_order_quantity: ad.stock,
      ad_quantity: Number(ad.buy_number) || ''
    }
  })

  return {
    ad_charge_total: advertisements.reduce((accumulator, currentValue) => accumulator + (currentValue.ad_quantity * currentValue.ad_unit_price), 0),
    ads: advertisements
  }
}

export function convertOrientationSlotsRequest(slots) {
  if (!slots || slots.length === 0) return []
  return slots.map((slot) => {
    return slot.orientation_time_slot_id
  })
}

export function convertAdsRequest(ads) {
  if (!ads || ads.length === 0) return {}
  let adsNormalized = {}

  ads.forEach((ad) => {
    adsNormalized = Object.assign({}, adsNormalized, {
      [`${ad.ad_id}`]: {
        number: ad.ad_quantity
      }
    })
  })
  return adsNormalized
}

export function convertCampusRecruitmentRequest(enrollment, method) {
  let request = {
    enlist_activity_id: Number(enrollment.campus_recruitment_id)

  }
  // if (Object.keys(enrollment).includes('specialIssue')) {
  //   const specialIssue = enrollment.specialIssue
  //   request = {
  //     welfare: specialIssue.enterprise_employee_benefits,
  //     education_training: specialIssue.enterprise_employee_training_introduction,
  //     provide_foreigners: specialIssue.enterprise_hire_foreigners,
  //     provide_internship: specialIssue.enterprise_hire_interns,
  //     provide_handicapped: specialIssue.enterprise_hire_disabled_people,
  //     contact_email: specialIssue.enterprise_hr_contact_email,
  //     contact: specialIssue.enterprise_hr_contact_person,
  //     contact_tel: specialIssue.enterprise_hr_contact_tel,
  //     job_description: specialIssue.enterprise_services,
  //     content: specialIssue.enterprise_recruiting_description,
  //     relationship_enterprise: specialIssue.enterprise_related_company,
  //     remark: specialIssue.enterprise_work_portfolio,
  //     is_daylight: specialIssue.enterprise_is_nine_to_five,
  //     is_shift: specialIssue.enterprise_is_shift_work, // TODO convert time to start_date, end_date,
  //     is_flextime: specialIssue.enterprise_is_flextime,
  //     daylight_start_date: specialIssue.enterprise_shift_schedule.length > 0
  //       ? moment(specialIssue.enterprise_shift_schedule[0].start_time).format('HH:mm')
  //       : '09:00',
  //     daylight_end_date: specialIssue.enterprise_shift_schedule.length > 0
  //       ? moment(specialIssue.enterprise_shift_schedule[0].end_time).format('HH:mm')
  //       : '18:00',
  //     ...request
  //   }
  //   request.shift_period = specialIssue.enterprise_shift_schedule.map(shift => {
  //     return {
  //       start_time: moment(shift.start_time).format('HH:mm'),
  //       end_time: moment(shift.end_time).format('HH:mm')
  //     }
  //   })
  // }

  if (Object.keys(enrollment).includes('careerExpo')) {
    request = {
      enlist_exposition_count: enrollment.careerExpo.expo_booth_quantity,
      ...request
    }
  } else if (method === 'post') {
    request = {
      enlist_exposition_count: 0,
      ...request
    }
  }

  if (Object.keys(enrollment).includes('printAdvertising')) {
    request = {
      enlist_commodities: convertAdsRequest(enrollment.printAdvertising.ads),
      ...request
    }
  }

  if (Object.keys(enrollment).includes('recruitmentOrientations')) {
    request = {
      enlist_seminar_session_ids: convertOrientationSlotsRequest(enrollment.recruitmentOrientations.orientation_slots),
      ...request
    }
  }
  return request
}

export function convertJobOpeningRequest(job) {
  const request = {
    job_title: 'name',
    job_publishing_deadline: 'deadline',
    job_identity: 'job_identity_id',
    job_industry: 'job_category_id',
    job_years_experience: 'job_tenure',
    job_departments: 'job_department_id',
    job_region: 'country_id',
    job_subregion: 'area',
    job_content: 'content',
    job_miscellaneous: 'other',
    job_contact_person: 'contact',
    job_tel: 'tel',
    job_email: 'email',
    job_attachments: 'old_file',
    job_new_attachments: 'file'
  }
  let formData = new FormData()
  Object.keys(job).forEach(key => {
    if (key === 'job_new_attachments') {
      job[key].forEach((file, i) => {
        formData.append(`file[${i}]`, file)
      })
    } else if (key === 'job_attachments') {
      job[key].forEach((attachment, i) => {
        formData.append(
          `old_file[${i}]`,
          attachment.attachment_id
        )
      })
    } else if (key === 'job_departments') {
      job[key].forEach((dept, i) => {
        formData.append(`job_department_id[${i}]`, dept.department_value)
      })
    } else {
      if (request[key]) {
        formData.append(request[key], job[key])
      } else {
        console.log(key, 'request')
      }
    }
  })
  return formData
}

export function convertJobDetailsResponse(response) {
  return {
    job_id: response.id,
    job_title: response.name,
    job_published_at: response.created_at,
    job_publishing_deadline: response.deadline,
    job_industry: response.enterprise.jobCategory.name,
    job_identity: response.identities.map(identity => identity.name),
    job_years_experience: response.job_tenure,
    job_departments: response.departments.map(dept => dept.name).join(', '),
    job_location: `${response.country.name} ${response.area}`,
    job_miscellaneous: response.other,
    job_contact_person: response.contact,
    job_tel: response.tel,
    job_email: response.email,
    job_content: response.content,
    job_attachments: convertMedia(response.media),
    job_enterprise: convertEnterpriseResponse(response.enterprise)
  }
}

export function convertJobDetailsForEnterprise(response) {
  return {
    job_title: response.name,
    job_publishing_deadline: response.deadline === null ? '' : moment(response.deadline).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    job_identity: response.identities[0].id,
    job_industry: response.enterprise.jobCategory.id,
    job_years_experience: response.job_tenure,
    job_departments: response.departments.map(dept => {
      return {
        department_name: dept.name,
        department_value: dept.id
      }
    }),
    job_miscellaneous: response.other,
    job_attachments: convertMedia(response.media),
    job_content: response.content,
    job_region: response.country.id,
    job_subregion: response.area,
    job_contact_person: response.contact,
    job_tel: response.tel,
    job_email: response.email,
    job_opening_status: !!((response.deadline === null || moment().isBefore(response.deadline)))
  }
}
